import { filledFormService } from "@features/filledForm/filledFormService";
import { FilledFormOutputDTO } from "@features/filledForm/types";
import createEntitySlice from "@services/createEntitySlice";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Estendendo a interface EntityState para incluir o currentFilledFormId
interface ExtendedFilledFormState {
  items: FilledFormOutputDTO[];
  currentItem: FilledFormOutputDTO | null;
  loading: boolean;
  error: any;
  currentFilledFormId: string | null;
}

// Slice para gerenciar entidades do FilledForm
const {
  reducer: baseFilledFormReducer,
  actions: filledFormActions,
  fetchAll: fetchFilledForms,
  fetchById: fetchFilledFormById,
  createEntity: createFilledForm,
  updateEntity: updateFilledForm,
  deleteEntity: deleteFilledForm,
} = createEntitySlice<FilledFormOutputDTO>("filledForm", filledFormService);

// Slice adicional para gerenciar o ID do formulário preenchido globalmente
const filledFormIdSlice = createSlice({
  name: "filledFormId",
  initialState: null as string | null,
  reducers: {
    setCurrentFilledFormId: (_, action: PayloadAction<string>) => {
      return action.payload;
    },
    clearCurrentFilledFormId: () => {
      return null;
    },
  },
});

// Combinar o reducer base com o novo reducer
const filledFormReducer = (state: any, action: any) => {
  // Inicializar o estado se for undefined
  if (state === undefined) {
    return {
      ...baseFilledFormReducer(undefined, action),
      currentFilledFormId: null,
    };
  }
  
  // Processar ações do filledFormIdSlice
  if (action.type === 'filledFormId/setCurrentFilledFormId' || 
      action.type === 'filledFormId/clearCurrentFilledFormId') {
    return {
      ...baseFilledFormReducer(state, action),
      currentFilledFormId: filledFormIdSlice.reducer(state.currentFilledFormId, action),
    };
  }
  
  // Para outras ações, apenas usar o reducer base
  return {
    ...baseFilledFormReducer(state, action),
    currentFilledFormId: state?.currentFilledFormId || null,
  };
};

// Exportar tudo
export {
  filledFormReducer,
  filledFormActions,
  fetchFilledForms,
  fetchFilledFormById,
  createFilledForm,
  updateFilledForm,
  deleteFilledForm,
};

// Exportar as ações do novo slice
export const { setCurrentFilledFormId, clearCurrentFilledFormId } = filledFormIdSlice.actions;

// Exportar o tipo estendido
export type { ExtendedFilledFormState };
